import { render, staticRenderFns } from "./thirdpartyStatsPage.vue?vue&type=template&id=6742aa28"
import script from "./thirdpartyStatsPage.vue?vue&type=script&lang=js"
export * from "./thirdpartyStatsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports